export { default } from './AppRoot.container.js'



// WEBPACK FOOTER //
// ./src/pages/AppRoot/index.js